import TagManager from 'react-gtm-module';

interface GTMEventData {
  event: string;
  [key: string]: any;
}

export type RegistrationFlow = 'email' | 'social';

export const initializeGTM = () => {
  const gtmId = process.env.GTM_ID;

  if (!gtmId) {
    console.warn('GTM_ID not configured');
    return;
  }

  TagManager.initialize({ gtmId });
};

export const trackEvent = (eventData: GTMEventData) => {
  try {
    TagManager.dataLayer({
      dataLayer: eventData,
    });
  } catch (trackingError) {
    console.error('GTM tracking failed:', trackingError);
  }
};

/** Fires when a TRM user account is successfully created. */
export const trackAccountCreation = (registrationFlow: RegistrationFlow) => {
  trackEvent({ event: 'account_creation', registration_flow: registrationFlow });
};
